module.exports = __webpack_public_path__ + "static/life-in-barcelona-8860a3d0a42d84bf41314018bf7bd5a5.mp4";